export default {"src":"/_next/static/media/settingsIcon.a967240b.svg","height":32,"width":38};